<script setup lang="ts">
import IconButton from "~/components/design/buttons/IconButton.vue";
defineProps({
  text: String,
  size: {
    type: String,
    default() {
      return 'md'
    }
  },
  color: {
    type: String,
    default() {
      return 'primary'
    }
  },
  textColour: {
    type: String,
    default() {
      return 'white'
    }
  },
  to: String
})
</script>

<template>

  <icon-button :size="size" class="pr-2" :text="text" :color="color" :to="to" :text-color="textColour" icon="mdi-arrow-top-right-thin" />
</template>

<style scoped>

</style>
